// Build de homologação (configuração "homologacao" do angular.json): o app nativo usa os servidores de homologação.
export const AMBIENTE: 'producao' | 'homologacao' = 'homologacao';
